import React from 'react';
import { FModal } from '@components';

export const ModalUpload = ({ modalIsOpen, setModalIsOpen }) => {
  return (
    <FModal
      isOpen={modalIsOpen}
      close={false}
      onClose={() => setModalIsOpen(false)}
    >
      Os arquivos que não são imagens/pdf não serão anexados.
    </FModal>
  );
};
